import * as React from 'react'
import styled from 'styled-components'
import * as interfaces from 'static/interfaces'
import * as constants from 'static/constants'
import { agentService, otaReservationService } from 'core/services'
import { InputTextArea, InputRadio, Button } from 'components/atoms'

declare var window: interfaces.IWindow

interface IProps {
  target: any
  targetClass: 'tour' | 'tourGroup' | 'otaReservation' | 'user' | 'calendarMemo'
  internal: boolean
  external?: boolean
  handleAfterUpdate?: (target: any, params: any) => void
}

export const MemoModal: React.VFC<IProps> = ({
  target,
  targetClass,
  internal,
  external,
  handleAfterUpdate,
}) => {
  const [memo, setMemo] = React.useState(target?.memo)
  const [internalMemo, setInternalMemo] = React.useState(target?.internal_memo)
  const [col, setCol] = React.useState(internal ? 'internal_memo' : 'memo')
  const switchable = internal && external

  const handleUpdateMemo = React.useCallback(
    async (colName, value) => {
      const params = { [colName]: value }

      // 更新後の値を返したい場合はこれを上書きする
      let _target = target

      try {
        if (targetClass === 'tour') {
          await agentService.updateTourMemo(target.id, params)
        } else if (targetClass === 'tourGroup') {
          await agentService.updateTourGroupMemo(target.id, params)
        } else if (targetClass === 'otaReservation') {
          await otaReservationService.updateMemo(target.id, params)
        } else if (targetClass === 'user') {
          await agentService.updateGuide(target.id, { guide_attributes: params })
        } else if (targetClass === 'calendarMemo') {
          const { updatedCalendarMemo } = await agentService.setCalendarMemo(target.id, {
            ...target,
            ...params,
          })
          _target = updatedCalendarMemo
        } else {
          return
        }

        colName === 'memo' ? setMemo(value) : setInternalMemo(value)
        if (handleAfterUpdate) {
          handleAfterUpdate(_target, { [colName]: value })
        }
        window.globalModal.closeModal()
      } catch (e) {
        console.error(e)
      }
    },
    [target, handleAfterUpdate]
  )

  return (
    <ModalBodyWrapper>
      {switchable ? (
        <div className="switchArea">
          公開範囲
          <InputRadio
            name="type"
            options={[
              { id: 'internal_memo', label: 'エージェント限定', value: 'internal_memo' },
              { id: 'memo', label: 'ガイドにも公開する', value: 'memo' },
            ]}
            defaultValue={col}
            onChangeHandler={e => setCol(e.target.value)}
          />
        </div>
      ) : (
        <>
          {col === 'internal_memo'
            ? 'エージェント限定で公開されるメモです'
            : 'ガイドにも公開されるメモです'}
        </>
      )}
      <p className="memo-note link-note">
        リンクを埋め込む場合は<code>[表示テキスト](https://...)</code>
        のマークダウン形式で入力してください
      </p>
      <InputTextArea
        name={col}
        value={col === 'memo' ? memo || '' : internalMemo || ''}
        onChangeHandler={e =>
          col === 'memo' ? setMemo(e.target.value) : setInternalMemo(e.target.value)
        }
      />
      <div className="buttons">
        <Button
          handleClick={() => handleUpdateMemo(col, col === 'memo' ? memo : internalMemo)}
          primary={true}
        >
          決定
        </Button>
        <Button handleClick={() => window.globalModal.closeModal()}>キャンセル</Button>
      </div>
    </ModalBodyWrapper>
  )
}

const ModalBodyWrapper = styled.div`
  .switchArea {
    margin: 20px 0;
  }
  .link-note {
    font-size: 12px;
    color: ${constants.COLORS.subText};
    margin-top: 8px;
  }
  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    button {
      width: 150px;
      margin-left: 20px;
    }
  }
`
